import { useState, useCallback } from "react"
import { FilterMatchMode } from "primereact/api"
import _ from "lodash"

export const useUserAccountFilters = (refetch, setFilters) => {
  const initFilters = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    staff_email_address: { value: null, matchMode: FilterMatchMode.CONTAINS },
    staff_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
  }

  const [globalFilterValue, setGlobalFilterValue] = useState("")
  const [globalFilterEmailValue, setGlobalFilterEmailValue] = useState("")
  const [globalFilterUUIDValue, setGlobalFilterUUIDValue] = useState("")

  const debouncedSetFilters = useCallback(
    _.debounce((newFilters) => {
      setFilters(newFilters)
      refetch()
    }, 500),
    [setFilters, refetch]
  )

  const clearGlobalFilter = () => {
    setGlobalFilterValue("")
    debouncedSetFilters((prevFilters) => ({
      ...prevFilters,
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    }))
  }

  const onGlobalFilterChange = (e) => {
    const value = e.target.value
    setGlobalFilterValue(value)
  }

  const onGlobalEmailFilterChange = (e) => {
    const value = e.target.value
    setGlobalFilterEmailValue(value)
  }

  const onGlobalUUIDFilterChange = (e) => {
    const value = e.target.value
    setGlobalFilterUUIDValue(value)
  }

  // const onBlurGlobalFilter = () => {
  //   setFilters((prevFilters) => ({
  //     ...prevFilters,
  //     global: { value: globalFilterValue, matchMode: FilterMatchMode.CONTAINS },
  //   }))
  //   refetch()
  // }

  // const onBlurGlobalEmailFilter = () => {
  //   setFilters((prevFilters) => ({
  //     ...prevFilters,
  //     staff_email_address: { value: globalFilterEmailValue, matchMode: FilterMatchMode.CONTAINS },
  //   }))
  //   refetch()
  // }

  // const onBlurGlobalUUIDFilter = () => {
  //   setFilters((prevFilters) => ({
  //     ...prevFilters,
  //     staff_id: { value: globalFilterUUIDValue, matchMode: FilterMatchMode.CONTAINS },
  //   }))
  //   refetch()
  // }

  const onKeyPress = (e) => {
    if (e.key === 'Enter') {
      setFilters((prevFilters) => ({
        ...prevFilters,
        global: { value: globalFilterValue, matchMode: FilterMatchMode.CONTAINS },
        staff_email_address: { value: globalFilterEmailValue, matchMode: FilterMatchMode.CONTAINS },
        staff_id: { value: globalFilterUUIDValue, matchMode: FilterMatchMode.CONTAINS },
      }))
      refetch()
    }
  }

  const clearAllFilters = () => {
    setFilters(initFilters)
    refetch()
  }

  const onFilterData = () => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      global: { value: globalFilterValue, matchMode: FilterMatchMode.CONTAINS },
      staff_email_address: { value: globalFilterEmailValue, matchMode: FilterMatchMode.CONTAINS },
      staff_id: { value: globalFilterUUIDValue, matchMode: FilterMatchMode.CONTAINS },
    }));
    refetch();
  }

  return {
    clearGlobalFilter,
    clearAllFilters,
    onFilterData,
    onGlobalFilterChange,
    onGlobalEmailFilterChange,
    onGlobalUUIDFilterChange,
    // onBlurGlobalFilter,
    // onBlurGlobalEmailFilter,
    // onBlurGlobalUUIDFilter,
    onKeyPress,
    setGlobalFilterValue,
    setGlobalFilterEmailValue,
    setGlobalFilterUUIDValue,
    globalFilterValue,
    globalFilterEmailValue,
    globalFilterUUIDValue,
  }
}
